<template>
  <div class="herde">
    <div class="herde-top" :class="{ 'hd-top': $route.path.indexOf('/bosyuu') != -1&&$route.path.indexOf('/serial_code') == -1 }">
      <div class="onshow" v-if="$route.path.indexOf('/bosyuu') == -1&&$route.path.indexOf('/serial_code') == -1" @click="shutDown()"></div>
    </div>
    <div :class="['herde_s', { actived: show }]" v-show="$route.path.indexOf('/bosyuu') == -1">
      <ul>
        <li @click="change('/')">
          <span>HOME</span>
          <div class="translate">ホーム</div>
        </li>
        <li @click="change('/news/newsJump')">
          <span>NEWS</span>
          <div class="translate">ニュース</div>
        </li>
        <li @click="change('/character')">
          <span>CHARACTER</span>
          <div class="translate">キャラクター</div>
        </li>
        <li @click="change('/system')">
          <span>SYSTEM</span>
          <div class="translate">システム</div>
        </li>
        <li @click="change('/fankit')">
          <span>FANKIT</span>
          <div class="translate">ファンキット</div>
          -
        </li>
        <li @click="change('/faq')">
          <span>FAQ</span>
          <div class="translate">よくある質問</div>
        </li>
        <li @click="change('/contact-1-hint')">
          <span>CONTACT</span>
          <div class="translate">問い合わせ</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header_s',
  components: {},
  data: () => ({
    show: false,
  }),
  created() {},
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    change(path, num) {
      this.show = false
      if (this.$route.path !== path) {
        this.$router.push(path)
        this.$store.state.url_type = num
      }
    },
    shutDown() {
      this.show = !this.show
    },
  },
}
</script>

<style lang="scss" scoped>
.herde {
  width: 100%;
  position: fixed;
  z-index: 5;
}
.herde_s {
  display: none;
  text-align: center;
  width: 100%;
  height: pxTorem(120px);
  display: flex;
  justify-content: center;
  position: relative;
  background: #fff;
  transition: 0.5s all;
  transform: translateX(0%);

  ul {
    // text-align: center;
    margin-top: pxTorem(31px);
    margin-bottom: pxTorem(31px);
    float: left;
    li {
      float: left;
      width: pxTorem(168px);
      height: pxTorem(60px);
      cursor: pointer;
      border-right: 3px dotted #dfdcce;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .caption {
        height: pxTorem(22px);
        margin-bottom: pxTorem(10px);
        // position: absolute;
        // left:pxTorem(2px); ;
      }
      .translate {
        font-size: pxTorem(12px);
        color: #9f61cb;
        line-height: 5px;
        font-family: "Noto Sans JP", sans-serif;
        font-weight: 400;
      }
    }
    .one {
      position: relative;
      .logo_1 {
        position: absolute;
        width: pxTorem(165px);
        left: pxTorem(-28px);
        top: pxTorem(-14px);
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .herde-top {
    width: 100%;
    height: MpxTorem(177px);
    background: url(../assets/images/home.png);
    background-size: 100%;
    .onshow {
      width: MpxTorem(118.3px);
      height: 100%;
      margin-left: MpxTorem(10px);
    }
  }
  .hd-top {
    background: url(../assets/images/homebosyuu.png);
    background-size: 100%;
  }
  .herde_s {
    display: block;
    z-index: 999;
    position: fixed;
    text-align: left;
    width: MpxTorem(418px);
    left: 0;
    height: MpxTorem(602px);
    transform: translateX(-100%);
    background: rgba(255, 255, 255, 0.1);
    box-sizing: border-box;
    padding: 0 MpxTorem(10px) MpxTorem(0px) 0;
    &.actived {
      transform: translateX(0);
    }

    // display:flex;
    // justify-content:center;
    // position: relative;

    ul {
      // text-align: center;
      width: 100%;
      margin-top: 0;
      margin-bottom: MpxTorem(0px);
      display: block;
      text-align: left;
      // background: blue;
      li:hover {
        background: #54dcfe;
        color: white;
      }
      // float: left;
      li {
        color: #54dcfe;
        clear: both;
        display: block;
        width: 100%;
        height: MpxTorem(136px);
        cursor: pointer;
        border-right: none;
        background: white;
        margin-bottom: 3%;
        box-sizing: border-box;
        padding-top: 10%;

        span {
          margin-top: 10%;
          margin-left: 16%;
          font-family: "Noto Sans JP", sans-serif;
          font-weight: 400;
          font-size: MpxTorem(16px);
        }
        .caption {
          height: MpxTorem(36px);
          margin-bottom: MpxTorem(10px);
        }
        .translate {
          margin-left: 16%;
          font-weight: 600;
          font-size: MpxTorem(30px);
          line-height: MpxTorem(30px);
          color: #54dcfe;
          font-family: "Noto Sans JP", sans-serif;
        }
      }
      .special {
        //  border-bottom:none;
        border-bottom: 3px dotted #dfdcce;
      }
      .one {
        position: relative;
        height: MpxTorem(273px);
        border-bottom: none;
        //  .logo_1{
        //    display: none;
        // }
        .logo_1 {
          left: 50%;
          margin-left: MpxTorem(-174px);
          width: MpxTorem(348px);
        }
      }
    }
  }
}
</style>
